<template>
  <ProductSection
    disable-mobile-background
    padding-only-title
    title="Zobacz w zestawie"
    :h-tag="false"
    v-if="similar && similar.length"
  >
    <LazyHydrate when-visible>
      <SliderTiles
        :breakpoints="{
          600: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        }"
        :items="similar"
        :slides-per-view="1"
        :loading="loading"
        nav-buttons-type="rounded"
      />
    </LazyHydrate>
  </ProductSection>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration';
import ProductSection from '~/components/Product/ProductSection';
import SliderTiles from '@/components/Sliders/SliderTiles.vue';

export default {
  name: 'ProductIncluded',
  components: { SliderTiles, LazyHydrate, ProductSection },
  props: {
    products: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: true,
      similar: null,
    };
  },
  created() {
    this.similar = this.products;
    this.loading = false;
  },
};
</script>
